import * as API from '../api/UsersAPI';

export function getAllUsers(order, filterData, token, getAll) {
  return API.getAllUsersNew(order, filterData, token, getAll);
}

export function getUsersByRole(role) {
  return API.getUsersByRole(role);
}

export function searchByEmail(email) {
  return API.searchByEmail(email.toLowerCase());
}

export function deleteUser(userId) {
  return API.deleteUser(userId);
}

export function getUser(id) {
  return API.getById(id);
}

export function updateUser(user) {
  const newUser = {
    userId: user.id,
    email: user.email,
    phone: user.phone,
    role: user.role,
  };
  return API.updateUser(newUser);
}

export function getUserParties(userId) {
  return API.getUserParties(userId);
}

export function resetPassword(email) {
  return API.resetPassword(email);
}

export function getUserStripeCustomers(userId) {
  return API.getUserStripeCustomers(userId);
}

export function getUserStripeCharges(userId, stripeCustomerId) {
  return API.getUserStripeCharges(userId, stripeCustomerId);
}
